import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { routeTree } from "./routeTree.gen";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

// Handle persona query parameter before authentication
// This needs to happen early since query parameters are lost during sign-in
const handlePersonaQueryParam = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const persona = urlParams.get("persona");

	if (persona) {
		console.log("🔍 Persona query parameter detected:", persona);
		// Save to localStorage so it survives the authentication process
		localStorage.setItem("pending-persona", persona);

		// Clean up the URL by removing the query parameter
		const url = new URL(window.location.href);
		url.searchParams.delete("persona");
		window.history.replaceState({}, document.title, url.toString());
	}
};

// Handle query parameter immediately
handlePersonaQueryParam();

// biome-ignore lint/style/noNonNullAssertion: <explanation>
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<RouterProvider router={router} />
		</StrictMode>,
	);
}
